export default function HardwareLogType(value: number): string {
    switch (value) {
      case 0:
        return "CPU";
      case 1:
        return "HardDriveFreeSize";  
      default:
        return value + " (Unknown)";
    }
  }